import { IGatsbyImageDataObject } from "@et/types/Gatsby";
import React from "react";
import { twMerge } from "tailwind-merge";

interface IVideoProps {
  posterImg: IGatsbyImageDataObject,
  videoSrc: string
  videoCss?: string
}

export function getVideo({ posterImg, videoSrc, videoCss }: IVideoProps) {
  const posterSrc = posterImg.gatsbyImageData.images.fallback
    ? posterImg.gatsbyImageData.images.fallback.src
    : ''

  return (
    <video
      className={twMerge('relative video z-3', videoCss)}
      disableRemotePlayback={true}
      muted={true}
      autoPlay={true}
      playsInline={true}
      loop={true}
      preload='none'
      poster={posterSrc}
      src={videoSrc}
      x-webkit-airplay="deny"
    />
  )
}